module.exports = __webpack_public_path__ + "static/img/ZA.24f1603f.png";